import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module, RECAPTCHA_SETTINGS, RecaptchaSettings, RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { WebcamModule } from 'ngx-webcam';
import { CookieService } from 'ngx-cookie-service';
import { IonicModule } from '@ionic/angular';
import { UserService } from '@services/user/user.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { LoginComponent } from './views/login/login.component';
import { CoreModule } from './core/core.module';
import { LoginService } from './services/login/login.service';

import { AuthInterceptor } from './core/interceptor/auth-interceptor';
import { UnauthorizedComponent } from './views/unauthorized/unauthorized.component';
import { PageCredentialComponent } from './views/login/page-credential/page-credential.component';
import { LoadingService } from './services/loading/loading.service';
import { InternationalizationService } from './services/utils/Internationalization.service';

export function getLanguage(internationalizationService: InternationalizationService): string {
    let language: string = internationalizationService.getLanguage();
    if (language.toLowerCase() === 'eu_es' || language.toLowerCase() === 'gl_es') {
        language = 'es_ES';
    }

    return language;
}

export function getCurrencyCode(userService: UserService): string {
    const permissions = userService.getPermissions();
    if (!permissions) {
        return 'EUR';
    }

    return permissions.centerOptions.currencyCode;
}

@NgModule({ declarations: [
    AppComponent,
    LoginComponent,
    UnauthorizedComponent,
    PageCredentialComponent
],
bootstrap: [AppComponent], imports: [CoreModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    SharedModule,
    RecaptchaV3Module,
    RecaptchaModule,
    RecaptchaFormsModule,
    WebcamModule, // <-- Module added here
    StoreModule.forRoot({}, {}),
    EffectsModule.forRoot([]),
    IonicModule.forRoot()], providers: [
    LoginService,
    LoadingService,
    {
        provide: LOCALE_ID,
        deps: [InternationalizationService],
        useFactory: getLanguage
    },
    {
        provide: DEFAULT_CURRENCY_CODE,
        deps: [UserService],
        useFactory: getCurrencyCode
    },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaKey },
    { provide: RECAPTCHA_SETTINGS, useValue: { siteKey: environment.recaptchaKeyV2 } as RecaptchaSettings },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true,
    },
    CookieService,
    provideHttpClient(withInterceptorsFromDi())
] })
export class AppModule {
    constructor(internationalizationService: InternationalizationService) {
        internationalizationService.importLocale();
    }
}
